var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/book-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33335 5.68265V14.6882C4.21141 14.3519 5.20643 14.1666 6.25002 14.1666C7.29362 14.1666 8.28863 14.3519 9.16669 14.6882V5.68265C8.38377 5.26373 7.37343 4.99992 6.25002 4.99992C5.12661 4.99992 4.11627 5.26373 3.33335 5.68265ZM10.8334 5.68265V14.6882C11.7114 14.3519 12.7064 14.1666 13.75 14.1666C14.7936 14.1666 15.7886 14.3519 16.6667 14.6882V5.68265C15.8838 5.26373 14.8734 4.99992 13.75 4.99992C12.6266 4.99992 11.6163 5.26373 10.8334 5.68265ZM10 4.2385C8.94393 3.66204 7.64007 3.33325 6.25002 3.33325C4.64996 3.33325 3.1641 3.76889 2.03887 4.51646C1.8064 4.67091 1.66669 4.93147 1.66669 5.21057V16.0439C1.66669 16.351 1.83558 16.6332 2.10622 16.7783C2.37686 16.9234 2.70538 16.9079 2.96117 16.738C3.78243 16.1924 4.93926 15.8333 6.25002 15.8333C7.56078 15.8333 8.71761 16.1924 9.53887 16.738C9.81828 16.9236 10.1818 16.9236 10.4612 16.738C11.2824 16.1924 12.4393 15.8333 13.75 15.8333C15.0608 15.8333 16.2176 16.1924 17.0389 16.738C17.2947 16.9079 17.6232 16.9234 17.8938 16.7783C18.1645 16.6332 18.3334 16.351 18.3334 16.0439V5.21057C18.3334 4.93147 18.1936 4.67091 17.9612 4.51646C16.8359 3.76889 15.3501 3.33325 13.75 3.33325C12.36 3.33325 11.0561 3.66204 10 4.2385Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.7446a82835bdd881b95c1c041a09f470.svg";
export { ForwardRef as ReactComponent };